import isNil from 'lodash/isNil';
import { ReactNode } from 'react';

export const resolveTooltipText = (children: ReactNode, explicit: string | undefined): string | undefined => {
  if (!isNil(explicit) && explicit.length > 0) return explicit;
  if (typeof children === 'string' && children.length > 0) return undefined;
  if (typeof children === 'number') return String(children);
  return undefined;
};
